export enum InsuranceLandingPageEnum {
  commercialBusiness = 'commercialBusiness',
  recruitment = 'recruitment',
  goodsInTransit = 'goodsInTransit',
  businessInsurance = 'businessInsurance',
}
